import CoveredInClass from './component';

import _routes from './routes';

export const routes = _routes;

export default CoveredInClass;



// WEBPACK FOOTER //
// ./containers/Group/CoveredInClass/index.js